/* eslint-disable no-unused-vars */
import React from 'react'
import './UomStyle.css'

const DotPagination = ({ currentPage, pageCount, onPageChange }) => {
    const handlePageClick = (e, pageNumber) => {
        e.preventDefault(); 
        onPageChange(pageNumber);
      };
      const effectivePageCount = Math.max(1, pageCount);
    return (
        <div className="dot-pagination-container">
      {Array.from({ length: effectivePageCount }, (_, index) => (
        <button
          key={index + 1}
          type="button" 
          className={`pagination-dot ${currentPage === index + 1 ? 'active-dot' : ''}`}
          onClick={() => onPageChange(index + 1)}
          aria-label={`Page ${index + 1}`}
          disabled={pageCount <= 1} 
        >
          <span className="dot-label">{index + 1}</span>
        </button>
      ))}
    </div>
      );
    };

export default DotPagination